import React from 'react';
import NotFoundView from './NotFoundView';

const NotFoundContainer = () => {
  return <NotFoundView />;
};

export default NotFoundContainer;
